import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignDesignSpecUserNeed } from '../Product.hooks';
import {
  ProductUserNeed,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignUserNeedDialog from './AssignUserNeedDialog';

export type DesignSpecAssignUserNeedDialogProps = BaseProductAssignDialogProps<'designSpecId'>;

const DesignSpecAssignUserNeedDialog: React.FC<DesignSpecAssignUserNeedDialogProps> = (
  props: DesignSpecAssignUserNeedDialogProps
) => {
  const {
    open,
    productId,
    designSpecId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductDesignSpec,
    isAssigning,
    error: assignError,
    assignUserNeeds
  } = useAssignDesignSpecUserNeed(productId, designSpecId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductDesignSpec) {
      onAssigned?.(updatedProductDesignSpec);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductDesignSpec]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignUserNeedDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'userNeed'
      )} to assign to the ${getProductEntityName('designSpec')}.`}
      onSubmit={(userNeeds: ProductUserNeed[]) => {
        assignUserNeeds({
          userNeedIds: userNeeds.map((userNeed: ProductUserNeed) => userNeed.id)
        });
      }}
    />
  );
};

export default DesignSpecAssignUserNeedDialog;
